import React from 'react';
import TeaserProduct from './TeaserProduct';
import TeaserNode from './TeaserNode';

export default function SearchResult(props) {
  if (props.hit.hasOwnProperty('variation_id_processed')) {
    return (
      <TeaserProduct hit={props.hit}/>
    )
  }
  else {
    return (
      <TeaserNode hit={props.hit}/>
    )
  }
}
